import {
    Box
} from '@mui/material';
import {
    type FC
} from 'react';

import type {
    ButtonBlockProps
} from './types';

import styles from './styles';

const ButtonBlock: FC<ButtonBlockProps> = (props) => {
    const {
        children,
        gap,
        isMobileReversed,
        sx
    } = props;

    return (
        <Box sx={[
            ...(Array.isArray(sx) ? sx : [
                sx
            ]),
            styles.wrapper,
            {
                flexDirection: {
                    md: 'row',
                    xs: isMobileReversed ? 'column-reverse' : 'column'
                },
                gap
            }
        ]}
        >
            {children}
        </Box>
    );
};

export default ButtonBlock;
